import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createIndividualDecision(_, individualDecision) {
    const response = await axios.post('/blade/individual-decisions', individualDecision);
    return response.data.individualDecision;
  },
  async getIndividualDecisions() {
    const response = await axios.get('/blade/individual-decisions');
    return response.data.individualDecisions;
  },
  async getIndividualDecision(_, { individualDecisionId }) {
    const { data } = await axios.get(`/blade/individual-decisions/${individualDecisionId}`);
    if (data.individualDecision) {
      if (data.individualDecision.choices != null) {
        for (let i = 0; i < data.individualDecision.choices.length; ++i) {
          if (data.individualDecision.choices[i].narratives == null) {
            data.individualDecision.choices[i].narratives = [];
          }
        }
      }
    }
    return data;
  },
  async getIndividualDecisionTypes({ dispatch }) {
    return dispatch('getIndividualDecision', { individualDecisionId: 'types' });
  },
  async updateIndividualDecision(_, individualDecision) {
    const response = await axios.patch(`/blade/individual-decisions/${individualDecision._id}`, individualDecision);
    return response.data.individualDecision;
  },
  async deleteIndividualDecision(_, { individualDecisionId, _id }) {
    const did = individualDecisionId || _id;
    const response = await axios.delete(`/blade/individual-decisions/${did}`);
    return response.data.individualDecision;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/individual-decisions.js